import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Brand } from '../../interfaces/Brand/Brand';
import { ComponentStyle } from '../../interfaces/Settings/SettingsV2/ComponentStyle';

export const brandLogoWidth = 180;
export const brandLogoHeight = 100;

export type BrandLogoProps = {
  brand: Brand;
  styleOverride?: ComponentStyle;
};

export const BrandLogo = ({ brand, styleOverride }: BrandLogoProps) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate(`/marka/${brand.slug}`)}
      sx={{
        width: brandLogoWidth,
        boxSizing: 'border-box',
        px: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        cursor: 'pointer',
        ...styleOverride,
      }}
    >
      <Box
        component='img'
        src={brand.logo}
        alt={brand.name}
        width={brandLogoWidth - 20}
        height={brandLogoHeight}
        sx={{
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};
